import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthFacade, Helper, SharedFacade, UserDetailsFacade } from '@piqet-angular/data';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { UserDetailsService } from 'libs/data/src/lib/services/user-details/user-details.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'piqet-angular-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit {
  isOverview = true;
  changedProfileImg = false;
  isPersonalInfo = false;
  isChangePassword = false;
  isEmailPreferences = false;
  image: any;
  stateList: any;

  constructor(
    public authFacade: AuthFacade,
    public sharedFacade: SharedFacade,
    private viewportScroller: ViewportScroller,
    public UserDetailsFacade: UserDetailsFacade,
    private spinnerService: NgxSpinnerService,
    private sharedService: SharedService
  ) {}

  async ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
    await this.userProfileOverViewData();
    this.UserDetailsFacade.userProfileImage$.subscribe((userProfileImage: any) => {
      this.image =
        (userProfileImage?.hasOwnProperty('imageThumb') && userProfileImage.imageThumb) ||
        userProfileImage
          ? 'data:image/jpg;base64,' + (userProfileImage.imageThumb || userProfileImage)
          : this.image;
    });
    this.sharedFacade.getCountryList();
  }

  async userProfileOverViewData() {
    this.UserDetailsFacade.userProfileOverview();
  }

  async savePersonalInfo(value: any) {
    this.UserDetailsFacade.saveUserPersonalData(value);
  }

  changePassword(value: any) {
    this.authFacade.changePassword(value);
  }

  UpdateUserEmailPreferences(value: any) {
    this.UserDetailsFacade.updateUserEmailPreferencesStatus(value);
  }

  updateUserProfileImage(value: any) {
    this.UserDetailsFacade.updateUserProfileImage(value);
  }

  imageForMainProfile(value: any) {
    this.image = value;
  }

  async getStatesById(value: any) {
    // this.sharedFacade.getStatesList(value);
    this.stateList = await this.GetStateListByCountryId(value);
  }

  async GetStateListByCountryId(countryId: any) {
    const stateList = await this.sharedService.getStates(countryId);
    const updatedStateData = stateList.data.map((item: any) => {
      return {
        ...item,
        name: Helper.convertToTitleCaseforState(item.name),
      };
    });
    return updatedStateData;
  }

  changeMenu(menu: any) {
    this.isOverview = false;
    this.isPersonalInfo = false;
    this.isChangePassword = false;
    this.isEmailPreferences = false;
    switch (menu) {
      case 'personalInfo':
        this.UserDetailsFacade.userPersonalInfo();
        this.isPersonalInfo = true;
        break;
      case 'changePassword':
        this.isChangePassword = true;
        break;
      case 'emailPreferences':
        this.UserDetailsFacade.getUserEmailPreferences();
        this.isEmailPreferences = true;
        break;
      default:
        this.isOverview = true;
        this.authFacade.clearError();
        this.UserDetailsFacade.clearError();
        break;
    }
  }
}
